import React, { Component } from 'react'
import ReactPaginate from "react-paginate";

class CsvUploadResultModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            offSet: 0,
            perPage: 15,
        }
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offSet: offset,
        });
    };

    getPagedItems = () => {
        const { skippedUsers } = this.props;
        const { offSet, perPage } = this.state;
        return (skippedUsers || []).slice(offSet, offSet + perPage);
    }

    render() {
        const { isOpen, onClose, totalAdded, totalSkipped, skippedUsers, actionLabel = 'added' } = this.props;
        const { currentPage, perPage } = this.state;
        const pagedItems = this.getPagedItems();
        const skippedList = skippedUsers || [];

        if (!isOpen) return null;

        return (
            <div className="user_popup active csv_upload_data">
                <span className="popup_overlay" onClick={onClose}></span>
                <div className="sundance_popup_createuser box_shadow upload_csv_sundance_popup_createuser">
                    <span className="closePopup pointer" onClick={onClose}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.899 0L5.656 4.242L1.414 0L0 1.414L4.242 5.656L0 9.898L1.414 11.312L5.656 7.07L9.899 11.312L11.313 9.898L7.071 5.656L11.313 1.414L9.899 0Z" fill="black" />
                        </svg>
                    </span>
                    <div className="bg_white">
                        <div className="p_10">
                            <div className="selection_pass text_center">
                                <label className="pass_label mb_10">
                                    You have successfully {actionLabel} {totalAdded} record(s)
                                </label>
                            </div>
                            <div className="selection_pass text_center">
                                <span className="pass_label color_red">
                                    {totalSkipped} record(s) were skipped
                                </span>
                            </div>
                        </div>
                        {skippedList.length > 0 ? (
                            <div className="table_content bg_td_table">
                                <div className="table_wrap">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Email</th>
                                                <th>Error</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagedItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td className='text_left'>{item.email}</td>
                                                    <td>{item.error}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div className="p_10 text_center" style={{ color: '#888' }}>
                                No skipped users.
                            </div>
                        )}
                        {skippedList.length > 0 ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={Math.ceil(skippedList.length / perPage)}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={currentPage}
                                />
                            </div>
                        ) : ''}
                        <div className="field_row text_center pb_25 mb_0">
                            <button className="uppercase active" onClick={onClose}>OK</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CsvUploadResultModal
